<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_ii"></a><strong><span class="smallcaps">FORGE BOOKS BY WALTER J. BOYNE</span></strong></p>
<p class="image"><img alt="Image" src="images/line.jpg"/></p>
<p class="center-para"><em>Dawn Over Kitty Hawk</em></p>
<p class="center-para"><em>Operation Iraqi Freedom</em></p>
<p class="center-para"><em>Roaring Thunder</em></p>
<p class="center-para"> <em>Today’s Best Military Writing</em> (editor)</p>
<p class="center-para"><em>Hypersonic Thunder</em></p>
<p class="center-para"><em>Supersonic Thunder</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?9c7a2a3e